import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Card, Container, Spinner, Badge, Pagination } from "react-bootstrap";
import { getUsers, } from "../../store/slices/user";
import "../../table.css";
import { Link } from "react-router-dom";

export default function ActiveUsers() {
  const dispatch = useDispatch();
  const { users, loading, error, pagination } = useSelector(
    (state) => state.user
  );
  const [page, setPage] = useState(1);
  const [limit] = useState(20);

  useEffect(() => {
    dispatch(getUsers({ page, limit }));
  }, [dispatch, page, limit]);




  const totalPages = pagination?.totalPages || 1;

  const buildPages = () => {
    if (totalPages <= 6) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages = [];
    if (page > 3) { pages.push(1); if (page > 4) pages.push("..."); }
    for (let i = Math.max(1, page - 1); i <= Math.min(totalPages, page + 1); i++) pages.push(i);
    if (page < totalPages - 2) { if (page < totalPages - 3) pages.push("..."); pages.push(totalPages); }
    return pages;
  };

  return (
    <>

      <div className="breadcrumb-bar mx-1" >
        <div className="container-fluid">
          <div className="d-flex  flex-row align-items-center justify-content-between gap-2 py-2">

            <div className="breadcrumb-left d-flex align-items-center flex-wrap">
              <Link to="/admin/home" className="breadcrumb-link active my-2">
                Home
              </Link>

              <span className="breadcrumb-separator mx-2">
                <i className="bi bi-chevron-right"></i>
              </span>

              <span
                className="breadcrumb-link inactive"

              >
                Active Users
              </span>

            </div>

          </div>
        </div>
      </div>


      <div className="ud-page-wrap">
        <Container fluid>

          <div className="ud-header">
            <h2 className="ud-main-title">Active Users</h2>

          </div>

          <Card className="ud-table-card">
            <Card.Body className="p-0">
              {loading ? (
                <div className="ud-loading-state">
                  <Spinner animation="border" className="ud-spinner" />
                  <span className="ud-loading-text">Loading users...</span>
                </div>
              ) : error ? (
                <div className="ud-error-state">{error}</div>
              ) : (
                <div className="ud-scroll-wrap">
                  <Table hover borderless className="ud-table align-middle mb-0">
                    <thead >
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Referral Code</th>
                        <th>Referred By</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users?.length > 0 ? (
                        users.map((user, idx) => (
                          <tr key={user._id}>
                            <td>{idx + 1}</td>
                            <td>
                              <div className="ud-user-cell">
                                {/* <span className="ud-avatar">
                                                                    {getInitials(user.name)}
                                                                </span> */}
                                <span className="ud-user-name">{user.name}</span>
                              </div>
                            </td>
                            <td className="ud-email">{user.email}</td>
                            <td>{user.mobileNumber}</td>
                            <td>
                              <span className="ud-ref-badge">{user.referralCode}</span>
                            </td>
                            <td>
                              <span className="ud-refby-name">{user?.referredByName || "—"}</span>
                              {user.referredByCode && (
                                <span className="ud-refby-code">{user.referredByCode}</span>
                              )}
                            </td>
                            <td>
                              <Badge
                                className={
                                  user.status === "active"
                                    ? "ud-status-badge ud-status-active"
                                    : "ud-status-badge ud-status-pending"
                                }
                              >
                                {user.status}
                              </Badge>
                            </td>
                            <td>
                              {!user.isApproved ? (
                                ""
                              ) : (
                                <Badge className="ud-approved-badge">Approved</Badge>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={7} className="ud-empty-state">
                            No users found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
            </Card.Body>
          </Card>

          {/* --------------- > Pagination */}
          {!loading && !error && users?.length > 0 && (
            <div className="ud-pagination-wrap mb-5">
              <Pagination className="ud-pagination mb-0">
                <Pagination.Prev
                  disabled={page === 1}
                  onClick={() => setPage((p) => p - 1)}
                />
                {buildPages().map((p, i) =>
                  p === "..." ? (
                    <Pagination.Ellipsis key={`ellipsis-${i}`} disabled />
                  ) : (
                    <Pagination.Item
                      key={p}
                      active={page === p}
                      onClick={() => setPage(p)}
                    >
                      {p}
                    </Pagination.Item>
                  )
                )}
                <Pagination.Next
                  disabled={page === totalPages}
                  onClick={() => setPage((p) => p + 1)}
                />
              </Pagination>
            </div>
          )}

        </Container>
      </div >
    </>
  );
}